import { ReactIcon } from '@/components/react/ui/ReactIcon';
import { cva, cx, type VariantProps } from '@/cva.config';

const alertVariants = cva({
  base: 'text-blurb-text-danger bg-blurb-bg-danger-subtlest flex items-center gap-1 p-1 text-base transition-all duration-150 ease-in rounded',
  variants: {
    size: {
      small: ['text-sm'],
      medium: ['text-base'],
      large: ['text-lg'],
    },
  },
  defaultVariants: {
    size: 'small',
  },
});

interface AlertProps extends VariantProps<typeof alertVariants> {
  message: string;
}

export const Alert = ({ message, size }: AlertProps) => {
  return (
    <div className={cx(alertVariants({ size }))}>
      <ReactIcon className="text-icon-danger" name="error" />
      <p className="text-blurb-text-bold">{message}</p>
    </div>
  );
};
